module.exports = __webpack_public_path__ + "img/PARIMATCH.BY.c1cdf75b.svg";